import React from "react";
import MainTemplate from "../../components/MainTemplate/MainTemplate";
import CardBackground from "../../components/MainTemplate/CardBackground";
import ProfileUpdateChild from "./ProfileUpdateChild";
import { useLocation } from "react-router-dom";

const ProfileUpdate = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <ProfileUpdateChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default ProfileUpdate;
